import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchRawReferrals } from "../../services/rawReferrals";
import { STATUS } from "../../constants";

export const getRawReferrals = createAsyncThunk("rawReferrals/fetchRawReferrals", async (source) => {
  const response = await fetchRawReferrals(source);
  return response.data;
});

const rawReferralsSlice = createSlice({
  name: "raw_referrals",
  initialState: { data: [], status: STATUS.DEFAULT },
  reducers: {},
  extraReducers: {
    [getRawReferrals.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.status = STATUS.SUCCEED;
    },
    [getRawReferrals.rejected]: (state) => {
      state.status = STATUS.FAILED;
    },
    [getRawReferrals.pending]: (state) => {
      state.status = STATUS.LOADING;
    },
  },
});

export default rawReferralsSlice;
